import React from 'react';
import WorkRegister from './WorkRegister';

/**
 * 作業予定一覧・新規作成
 *
 * @param {*} props
 */
const WorkScheduleRegister = props => (
  <WorkRegister isWorkSchedule={true} {...props} />
);

export default WorkScheduleRegister;



// WEBPACK FOOTER //
// ./src/pages/WorkScheduleRegister.jsx